export const saveUserData = (value) => {
    return {
        type: "SAVE_USER_DETAIL",
        payload:value,
    };
};